import { render, staticRenderFns } from "./ManterGrupoNotificacaoView.vue?vue&type=template&id=272ba56b"
import script from "./ManterGrupoNotificacaoView.vue?vue&type=script&lang=js"
export * from "./ManterGrupoNotificacaoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports